import Container from "../components/Container";
import { BsHouseCheckFill } from "react-icons/bs";
import { FaChalkboardTeacher } from "react-icons/fa";
import {Link} from "react-router";

export default function About(props) {
    return <>

        <Container
            transparent
            padding={""}
            shadow={false}
            size={"w-full"}
            className="relative"
            outerPadding={""}
        >
            <div className={`min-w-[100vw] md:min-w-[80dvw]`}>
                <img className="h-[90dvh] w-full object-cover "
                     src="img/musa-ortac-HrrWNCpoOu8-unsplash.jpg" alt="cover-image"/>

                <div
                    className="absolute inset-0 bg-gradient-to-br from-gray-700 to-slate-900 opacity-70"></div>

                <div
                    className="absolute bottom-0 right-0 w-full flex flex-col md:flex-row justify-between items-center">
                    <div
                        className={"pt-24 pb-8 md:pb-16 px-6 md:px-10 space-y-6 text-center md:text-left text-white  rounded-3xl"}>
                        <div>
                            <div className={"font-bold text-2xl md:text-5xl"}>About Us</div>
                        </div>
                        <div className={"md:text-lg md:font-semibold"}>
                            We are empowering the real estate stakeholder ecosystem with innovative tools and advanced
                            technologies to support their growth.
                        </div>
                    </div>
                </div>
            </div>
        </Container>

        <Container transparent shadow={false} padding={""}>

            <h2 className={"font-bold text-3xl mb-6"}>What We Do</h2>

            <div className="flex flex-col md:flex-row justify-between gap-4">
                <div className="flex-1 bg-blue-500 text-white p-10 rounded-xl">
                    <div className={"mb-4"}>
                        <BsHouseCheckFill className={"text-7xl text-blue-200"}/>
                    </div>
                    <h3 className={"font-semibold text-xl my-2"}>Property Valuations</h3>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab consequuntur dicta
                        exercitationem impedit ipsam laboriosam nostrum officiis placeat veritatis voluptates.
                        Atque, cumque eaque enim nesciunt quaerat qui quis sunt temporibus?
                    </p>
                </div>

                <div className="flex-1 bg-blue-500 text-white p-10 rounded-xl">
                    <div className={"mb-4"}>
                        <FaChalkboardTeacher className={"text-7xl text-blue-200"}/>
                    </div>
                    <h3 className={"font-semibold text-xl my-2"}>Property Scouts Training</h3>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab consequuntur dicta
                        exercitationem impedit ipsam laboriosam nostrum officiis placeat veritatis voluptates.
                        Atque, cumque eaque enim nesciunt quaerat qui quis sunt temporibus?
                    </p>
                </div>

                <div className="flex-1 bg-blue-500 text-white p-10 rounded-xl">
                    <div className={"mb-4"}>
                        <FaChalkboardTeacher className={"text-7xl text-blue-200"}/>
                    </div>
                    <h3 className={"font-semibold text-xl my-2"}>Property Scouts Training</h3>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab consequuntur dicta
                        exercitationem impedit ipsam laboriosam nostrum officiis placeat veritatis voluptates.
                        Atque, cumque eaque enim nesciunt quaerat qui quis sunt temporibus?
                    </p>
                </div>

                <div className="flex-1 bg-blue-500 text-white p-10 rounded-xl">
                    <div className={"mb-4"}>
                        <FaChalkboardTeacher className={"text-7xl text-blue-200"}/>
                    </div>
                    <h3 className={"font-semibold text-xl my-2"}>Property Scouts Training</h3>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab consequuntur dicta
                        exercitationem impedit ipsam laboriosam nostrum officiis placeat veritatis voluptates.
                        Atque, cumque eaque enim nesciunt quaerat qui quis sunt temporibus?
                    </p>
                </div>
            </div>

            <div className={"w-[100vw]"}></div>
        </Container>
    </>
}